// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment-timezone'
import { useBooleanToggle } from 'hooks'
import handleApplicationMaintenanceWindow from '../helpers/handleApplicationMaintenanceWindow'
import applicationIsWithinMaintenanceMode from '../helpers/applicationIsWithinMaintenanceMode'

const useHandleApplicationMaintenanceWindow = () => {
  const dispatch = useDispatch()

  const [
    isWithinMaintenanceWindow,
    toggleIsWithinMaintenanceWindow
  ] = useBooleanToggle(() => (
    applicationIsWithinMaintenanceMode(moment(Date.now()).tz('America/New_York'))
  ))

  useEffect(() => {
    dispatch(handleApplicationMaintenanceWindow(toggleIsWithinMaintenanceWindow))
  }, [])

  return isWithinMaintenanceWindow
}

export default useHandleApplicationMaintenanceWindow
